<template>
  <div class="certs">
    <figure v-for="c in certs" :key="c.name" class="cert card">
      <div class="paper"><img :src="c.img" :alt="c.name" loading="lazy" /></div>
      <figcaption>
        <div class="name">{{ c.name }}</div>
        <div class="issuer">{{ c.issuer }}</div>
      </figcaption>
    </figure>
  </div>
</template>

<script>
import { certifications } from '@/data/company';

export default {
  name: 'CertsSection',
  data() { return { certs: certifications }; },
};
</script>

<style scoped>
.certs { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 16px; }
.cert { margin: 0; overflow: hidden; display: flex; flex-direction: column; }
.paper { background: #f3f0ea; padding: 16px; height: 240px; display: flex; align-items: center; justify-content: center; }
.paper img { max-height: 100%; max-width: 100%; object-fit: contain; box-shadow: 0 6px 18px rgba(0,0,0,0.12); }
figcaption { padding: 14px 16px 16px 16px; }
.name { font-size: 15px; font-weight: 700; }
.issuer { font-size: 12px; color: var(--muted); margin-top: 4px; line-height: 1.5; }
@media (max-width: 900px) { .certs { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
@media (max-width: 600px) { .certs { grid-template-columns: repeat(2, minmax(0, 1fr)); } .paper { height: 190px; } }
</style>
